module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWAAAABACAYAAAAkuq3OAAAABmJLR0QA/wD/AP+gvaeTAAAAzklEQVR4nO3UwQ3CQBAEwT1iJQ+TCLEeKSDZuCVUFcDMr2cAAAAAAAAAAAAAAAAAAAAAAAAAAACAX1t3H+69XzNz3P0LcNJzrfW+cvBx5RgA3xNggIgAA0QEGCAiwAARAQaICDBARIABIgIMEBFggIgAA0QEGCAiwAARAQaICDBARIABIgIMEBFggIgAA0QEGCAiwAARAQaICDBARIABIgIMEBFggIgAA0QEGCAiwAARAQaICDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8Lc+PmUFQEENTdMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/minus/PNG-minus-white.png
// module id = 93
// module chunks = 0